package com.appcreator.blueprint.firebase.auth

import com.appcreator.blueprint.core.Action
import com.appcreator.blueprint.core.ActionClass
import com.appcreator.blueprint.core.InputProperty
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
@SerialName("FirebaseAuthDeleteUser")
@ActionClass(
    group = FirebaseAuthConsts.group,
    title = "Delete User",
    isExtraPlugin = true,
    availableFrom = "0.0.1"
)
class FirebaseAuthDeleteUserAction(
    @InputProperty(
        title = "Configure App Check",
        availableFrom = "0.0.1"
    )
    val configureAppCheck: Boolean?

): Action
